var _rect, _path, _path2, _path3, _path4, _path5, _path6, _rect2, _path7, _path8, _path9, _path0, _path1, _path10, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedalhaFabula2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 214,
    height: 260,
    viewBox: "0 0 214 260",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 213,
    height: 260,
    rx: 8,
    fill: "#ECE6F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M170.5 112.44C170.5 149.683 142.719 168.305 109.699 179.106C107.97 179.656 106.091 179.63 104.381 179.031C71.2812 168.305 43.5 149.683 43.5 112.44V60.2984C43.5 58.3228 44.3363 56.4282 45.8248 55.0313C47.3134 53.6344 49.3323 52.8496 51.4375 52.8496C67.3125 52.8496 87.1562 43.9111 100.967 32.589C102.649 31.2408 104.788 30.5 107 30.5C109.212 30.5 111.351 31.2408 113.033 32.589C126.923 43.9856 146.688 52.8496 162.562 52.8496C164.668 52.8496 166.687 53.6344 168.175 55.0313C169.664 56.4282 170.5 58.3228 170.5 60.2984V112.44Z",
    fill: "url(#paint0_linear_2162_30876)",
    stroke: "url(#paint1_linear_2162_30876)",
    strokeWidth: 3.91429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M125.515 108.379L125.474 108.544L125.541 108.699L130.466 120.026L125.601 135.109L107.473 141.479L95.1719 138.526L86.4043 134.143L83.6689 126.395L95.082 124.493L96.0703 124.328L95.3447 123.638L85.0605 113.843L86.4824 108.632L86.5166 108.506L86.4854 108.379L83.6631 97.0908L105.936 99.9961L106 100.004L106.064 99.9961L128.336 97.0908L125.515 108.379Z",
    fill: "#FF7A21",
    stroke: "#100F11"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M96.3143 127.026L93.5586 135.97L85.8584 132.142L84.1992 127.474L96.3143 127.026Z",
    fill: "#FFEDB8",
    stroke: "#100F11"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M106.01 127.301C103.56 127.301 86.41 119.951 83.225 113.826C83.96 111.866 85.185 110.151 86.655 108.436C84.94 105.251 83.96 101.821 83.96 97.9012C83.96 96.4312 84.94 95.4512 86.41 95.4512C91.729 95.3989 96.8788 97.3191 100.865 100.841C104.278 100.359 107.742 100.359 111.155 100.841C115.075 97.4112 119.975 95.4512 125.61 95.4512C127.08 95.4512 128.06 96.4312 128.06 97.9012C128.06 101.821 127.08 105.251 125.365 108.436C126.835 110.151 128.06 111.866 128.795 113.826C125.61 119.951 108.46 127.301 106.01 127.301ZM106.01 127.301V119.951M98.66 110.151V111.376M108.46 119.951H103.56M113.36 110.151V111.376",
    stroke: "#100F11",
    strokeWidth: 4.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M92.045 138.326C94.1151 136.745 95.79 134.705 96.9379 132.367C98.0858 130.029 98.6753 127.456 98.66 124.851H82C83.96 134.651 94.005 142.001 106.01 142.001C119.485 142.001 130.51 132.691 130.51 121.176C130.51 118.481 130.02 116.031 128.795 113.826",
    stroke: "#100F11",
    strokeWidth: 4.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M105.5 78C112.203 78 118.247 79.3873 122.597 81.6064C126.973 83.8395 129.5 86.8343 129.5 90C129.5 93.1657 126.973 96.1605 122.597 98.3936C118.247 100.613 112.203 102 105.5 102C98.7968 102 92.753 100.613 88.4033 98.3936C84.0265 96.1605 81.5 93.1657 81.5 90C81.5 86.8343 84.0265 83.8395 88.4033 81.6064C92.753 79.3873 98.7968 78 105.5 78Z",
    fill: "#0E1872",
    stroke: "#100F11"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 90.5,
    y: 66,
    width: 30,
    height: 26,
    fill: "#0E1872",
    stroke: "#100F11"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M106 85C110.111 85 113.816 85.4446 116.478 86.1543C117.812 86.5101 118.856 86.9259 119.555 87.3662C120.278 87.8223 120.5 88.2179 120.5 88.5C120.5 88.7821 120.278 89.1777 119.555 89.6338C118.856 90.0741 117.812 90.4899 116.478 90.8457C113.816 91.5554 110.111 92 106 92C101.889 92 98.184 91.5554 95.5225 90.8457C94.188 90.4899 93.1438 90.0741 92.4453 89.6338C91.722 89.1777 91.5 88.7821 91.5 88.5C91.5 88.2179 91.722 87.8223 92.4453 87.3662C93.1438 86.9259 94.188 86.5101 95.5225 86.1543C98.184 85.4446 101.889 85 106 85Z",
    fill: "#F936BB",
    stroke: "#100F11"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M105.5 75.525C114.972 75.525 122.65 73.057 122.65 70.0125C122.65 66.968 114.972 64.5 105.5 64.5C96.0283 64.5 88.35 66.968 88.35 70.0125C88.35 73.057 96.0283 75.525 105.5 75.525Z",
    stroke: "#100F11",
    strokeWidth: 4.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M88.35 70.0127C88.35 71.8502 90.8 77.3627 90.8 81.0377V88.3877C90.8 91.5114 97.415 93.9002 105.5 93.9002C113.585 93.9002 120.2 91.5114 120.2 88.3877V81.0377C120.2 77.3627 122.65 71.8502 122.65 70.0127",
    stroke: "#100F11",
    strokeWidth: 4.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M120.2 81.0376C120.2 84.1613 113.585 86.5501 105.5 86.5501C97.415 86.5501 90.8 84.1613 90.8 81.0376",
    stroke: "#100F11",
    strokeWidth: 4.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M90.8 81.4058C84.92 83.427 81 86.5508 81 90.2258C81 96.2895 92.025 101.251 105.5 101.251C118.975 101.251 130 96.2895 130 90.2258C130 86.5508 126.08 83.427 120.2 81.4058",
    stroke: "#100F11",
    strokeWidth: 4.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M80.0639 202.136V222.5H77.2401L66.8892 207.565H66.7003V222.5H63.6278V202.136H66.4716L76.8324 217.091H77.0213V202.136H80.0639ZM84.3072 222.5V207.227H87.2802V222.5H84.3072ZM84.5856 205.189L86.9123 200.605H90.0444L86.962 205.189H84.5856ZM104.345 207.227L98.8068 222.5H95.625L90.0767 207.227H93.2685L97.1364 218.98H97.2955L101.153 207.227H104.345ZM113.202 222.808C111.697 222.808 110.401 222.487 109.314 221.844C108.234 221.194 107.399 220.283 106.809 219.109C106.225 217.929 105.934 216.547 105.934 214.963C105.934 213.399 106.225 212.02 106.809 210.827C107.399 209.634 108.221 208.702 109.275 208.033C110.335 207.363 111.575 207.028 112.993 207.028C113.855 207.028 114.69 207.171 115.499 207.456C116.308 207.741 117.033 208.188 117.676 208.798C118.319 209.408 118.827 210.2 119.198 211.175C119.569 212.143 119.755 213.319 119.755 214.705V215.759H107.614V213.531H116.841C116.841 212.749 116.682 212.056 116.364 211.453C116.046 210.843 115.598 210.363 115.022 210.011C114.452 209.66 113.782 209.484 113.013 209.484C112.178 209.484 111.449 209.69 110.826 210.101C110.209 210.505 109.732 211.036 109.394 211.692C109.062 212.341 108.897 213.047 108.897 213.81V215.55C108.897 216.571 109.076 217.439 109.434 218.155C109.798 218.871 110.305 219.418 110.955 219.795C111.605 220.167 112.364 220.352 113.232 220.352C113.795 220.352 114.309 220.273 114.773 220.114C115.237 219.948 115.638 219.703 115.976 219.378C116.314 219.053 116.573 218.652 116.752 218.175L119.566 218.682C119.34 219.51 118.936 220.236 118.353 220.859C117.776 221.476 117.05 221.956 116.175 222.301C115.307 222.639 114.316 222.808 113.202 222.808ZM126.026 202.136V222.5H123.053V202.136H126.026ZM137.396 222.5V220.273L144.287 213.134C145.023 212.358 145.629 211.679 146.107 211.095C146.59 210.505 146.952 209.945 147.19 209.415C147.429 208.884 147.548 208.321 147.548 207.724C147.548 207.048 147.389 206.465 147.071 205.974C146.753 205.477 146.319 205.096 145.768 204.831C145.218 204.559 144.598 204.423 143.909 204.423C143.18 204.423 142.544 204.572 142 204.871C141.456 205.169 141.039 205.59 140.747 206.134C140.455 206.677 140.31 207.313 140.31 208.043H137.376C137.376 206.803 137.661 205.719 138.232 204.791C138.802 203.863 139.584 203.144 140.578 202.634C141.572 202.116 142.703 201.858 143.969 201.858C145.248 201.858 146.375 202.113 147.349 202.624C148.33 203.127 149.096 203.817 149.646 204.692C150.196 205.56 150.472 206.541 150.472 207.635C150.472 208.391 150.329 209.13 150.044 209.852C149.766 210.575 149.278 211.38 148.582 212.268C147.886 213.15 146.919 214.221 145.679 215.48L141.632 219.716V219.865H150.8V222.5H137.396Z",
    fill: "#4C4452"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2162_30876",
    x1: 107,
    y1: 30.5,
    x2: 107,
    y2: 179.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#015560"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.538462,
    stopColor: "#2BDE78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995192,
    stopColor: "#00B4B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2162_30876",
    x1: 107,
    y1: 30.5,
    x2: 107,
    y2: 179.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A7D8F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedalhaFabula2);
export default __webpack_public_path__ + "static/media/Medalha_fabula_2.33b045654435d700b78fda76406794b7.svg";
export { ForwardRef as ReactComponent };